module.exports = __webpack_public_path__ + "199f925bed6a1213784006ed59757d15.svg";